import {
  getContentDiscoveryObservable,
  getContentDiscoveryEpic,
} from './getContentDiscovery'

export const observables = {
  getContentDiscoveryObservable,
}

export default {
  getContentDiscoveryEpic,
}
